<label class="tw-inline-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-2" (click)="$event.stopPropagation()">
  <input type="checkbox" class="tw-peer tw-sr-only" role="switch" [attr.aria-label]="label" [formControl]="control" (change)="changed.emit($event)" />
  <span class="tw-flex tw-h-5 tw-w-10 tw-shrink-0 tw-items-center tw-rounded-full tw-bg-gray-200 tw-px-0.5 tw-transition-colors peer-checked:tw-justify-end peer-checked:tw-bg-blue-600 dark:tw-bg-gray-600">
    <span class="tw-h-4 tw-w-4 tw-rounded-full tw-bg-white tw-shadow-sm"></span>
  </span>
  @if (text) {
  <span class="tw-text-sm tw-text-gray-700 dark:tw-text-gray-200">{{ text }}</span>
  }
</label>
